"use client";

var __jsx = React.createElement;
import React, { useState } from "react";
import useAfterInitEffect from "@lib/hooks/use-after-initialization-effect";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
import { Checkbox } from "../ui/checkbox";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { BREAKPOINTS } from "@lib/constants";
import { useMediaQuery } from "react-responsive";
const MuscleCheckbox = _ref => {
  let {
    name,
    value = false,
    onChange = () => {},
    label,
    amount,
    icon,
    disabled = false,
    textClass,
    disabledOpacity = 0.5,
    disabledClass,
    dataTestId
  } = _ref;
  const {
    0: isChecked,
    1: setIsChecked
  } = useState(value);
  const {
    cssModules
  } = useCssModules();
  const t = useTranslations("Flights");
  const pathname = usePathname();
  const isFlightFilters = pathname.includes('flights/select');
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    checkboxRowClassName,
    checkboxTextClassName,
    checkboxAmountClassName,
    checkboxDetailsClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.checkbox) || {};
  useAfterInitEffect(() => {
    setIsChecked(value);
  }, [value]);
  const handleChange = event => {
    onChange(event);
  };
  const renderLabel = label => {
    let labelText = '';
    if (typeof label === 'string') {
      labelText = label;
    } else if (/*#__PURE__*/React.isValidElement(label) && label.props && label.props.children) {
      labelText = label.props.children;
    }
    if (labelText && typeof labelText === 'string') {
      const timeLabels = [t('BOOKING.FLIGHT_TIMES_OPTIONS.EARLY_MORNING'), t('BOOKING.FLIGHT_TIMES_OPTIONS.MORNING'), t('BOOKING.FLIGHT_TIMES_OPTIONS.AFTERNOON'), t('BOOKING.FLIGHT_TIMES_OPTIONS.NIGHT')];
      const hasTimeLabel = timeLabels.some(timeLabel => labelText.includes(timeLabel));
      if (hasTimeLabel && labelText.includes('(')) {
        const parts = labelText.split('(');
        if (parts.length === 2) {
          return [parts[0].trim(), "(".concat(parts[1])];
        }
      }
    }
    return [label];
  };
  const labelParts = renderLabel(label);
  return __jsx("div", {
    className: checkboxRowClassName
  }, __jsx(Checkbox, {
    name: name,
    checked: isChecked,
    onCheckedChange: checked => handleChange(checked === true),
    disabled: disabled,
    "data-testid": dataTestId
  }), __jsx("div", {
    className: "flex flex-row items-center gap-1"
  }, icon && __jsx("span", null, icon), __jsx("div", {
    style: {
      opacity: disabled ? disabledOpacity : 1
    },
    className: cn(disabledClass, 'flex gap-1')
  }, labelParts[0] && __jsx("span", {
    className: cn(checkboxTextClassName, textClass)
  }, labelParts[0]), labelParts[1] && __jsx("span", {
    className: cn(checkboxDetailsClassName, textClass)
  }, " ", labelParts[1]), amount ? __jsx("span", {
    className: checkboxAmountClassName
  }, "(", amount, ")") : null)));
};
export default MuscleCheckbox;